import { render, staticRenderFns } from "./ParamEdit.vue?vue&type=template&id=351a6713&scoped=true&"
import script from "./ParamEdit.vue?vue&type=script&lang=js&"
export * from "./ParamEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351a6713",
  null
  
)

export default component.exports